<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
        h2.primary--text {{$t('DataIntegration.dataIntegrationTemplate')}} - EDI Log

    code-editor(
      v-model="instance.body",
      language="application/json"
    )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>

export default {
  props: ['value'],
  data: function ()  {
    return {
      initObject: {
        type: 'Data Integration',
        body: '',
        entity: 'EdiLog',
        isRazor: true
      },
      instance: {}
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
